import * as actionTypes from './constants'
import { api } from 'app/modules/hubspot/api'

export function fetchHubspotFieldsSuccess({ fields }) {
  return {
    type: actionTypes.FETCH_HUBSPOT_FIELDS_SUCCESS,
    fields
  }
}

export function fetchHubspotAttributeMappingsSuccess({ mappings, allowAttributeDefaults, useCountryAcronyms, useStateAcronyms }) {
  return {
    type: actionTypes.FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS,
    mappings, allowAttributeDefaults, useCountryAcronyms, useStateAcronyms
  }
}

export function patchHubspotAttributeMappingsSuccess({ mappings, allowAttributeDefaults, useCountryAcronyms, useStateAcronyms }) {
  return {
    type: actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS,
    mappings, allowAttributeDefaults, useCountryAcronyms, useStateAcronyms
  }
}

export function patchHubspotAttributeMappingsError(err) {
  return {
    type: actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR,
    err
  }
}

export function patchHubspotAttributeMappingsStart() {
  return {
    type: actionTypes.PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START
  }
}

export function fetchHubspotFields() {
  return dispatch => {
    api.fetchHubspotFields().then(response => {
      dispatch(fetchHubspotFieldsSuccess(response))
    })
  }
}

export function fetchHubspotAttributeMappings() {
  return dispatch => {
    api.fetchHubspotMappings().then(response => {
      dispatch(fetchHubspotAttributeMappingsSuccess(response))
    })
  }
}

export function patchHubspotAttributeMappings(mappings, successCB = () => { }) {
  return dispatch => {
    dispatch(patchHubspotAttributeMappingsStart())
    api.patchHubspotMappings(mappings)
      .then(response => {
        successCB()
        dispatch(patchHubspotAttributeMappingsSuccess(response))
      })
      .catch(err => {
        dispatch(patchHubspotAttributeMappingsError(err))
      })
  }
}

export function searchHubspotUsersSuccess({ users }) {
  return {
    type: actionTypes.FETCH_HUBSPOT_USERS_SEARCH_SUCCESS,
    users
  }
}
  
export function searchHubspotUsersError(err) {
  return {
    type: actionTypes.FETCH_HUBSPOT_USERS_SEARCH_ERROR,
    err
  }
}
  
export function searchHubspotUsersStart() {
  return {
    type: actionTypes.FETCH_HUBSPOT_USERS_SEARCH_START,
  }
}
  
export function searchHubspotUsers(query) {
  return dispatch => { 
    dispatch(searchHubspotUsersStart())
    api.searchHubspotUsers(query).then(
      response => dispatch(searchHubspotUsersSuccess(response)),
      err => dispatch(searchHubspotUsersError(err))
    )
  }
}
  
export function fetchHubspotUserMappingsSuccess({ mappings, users }) {
  return {
    type: actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS,
    mappings,
    users
  }
}

export function fetchHubspotUserMappingsError(err) {
  return {
    type: actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_ERROR,
    err
  }
}
  
export const fetchHubspotUserMappingsStart = () => ({
  type: actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_STARTED
})

export function fetchHubspotUserMappings() {
  return dispatch => {
    dispatch(fetchHubspotUserMappingsStart())
    api.fetchHubspotUserMappings().then(
      response => dispatch(fetchHubspotUserMappingsSuccess(response)),
      err => dispatch(fetchHubspotUserMappingsError(err))
    )
  }
}
  
export function patchHubspotUserMappings(data, successCB) {
  return dispatch => { 
    dispatch(patchHubspotUserMappingsStarted())
    api.patchHubspotUserMappings(data).then(
      resp => {
        successCB && successCB()
        dispatch(patchHubspotUserMappingsSuccess(resp))
      },
      err => dispatch(patchHubspotUserMappingsFailed(err))
    )
  }
}

export function patchHubspotUserMappingsStarted() {
  return {
    type: actionTypes.PATCH_HUBSPOT_USER_MAPPINGS_START
  }
}
  
export function patchHubspotUserMappingsFailed(err) {
  return {
    type: actionTypes.PATCH_HUBSPOT_USER_MAPPINGS_FAILED,
    err
  }
}
  
export function patchHubspotUserMappingsSuccess({ mappings, users }) {
  return {
    type: actionTypes.FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS,
    mappings,
    users
  }
}

export function fetchHubSpotByEmail({ email }){
  return dispatch => {
    dispatch(fetchHubSpotByEmailStart(email))
    api.fetchHubSpotContactByEmail({ email })
    .then(response => {
      dispatch(fetchHubSpotSuccess(response, email))
    }).catch(
      err => dispatch(fetchHubSpotByEmailFailed(err, email))
    )
  }
}

export function fetchHubSpotByEmailStart(key) {
  return {
    type: actionTypes.FETCH_HUBSPOT_BY_EMAIL_STARTED,
    key
  }
}

export function fetchHubSpotByEmailFailed(err, key) {
  return {
    type: actionTypes.FETCH_HUBSPOT_BY_EMAIL_FAILED,
    err,
    key
  }
}

export function fetchHubSpotSuccess(data, key) {
  return {
    type: actionTypes.FETCH_HUBSPOT_BY_EMAIL_SUCCESS,
    data,
    key
  }
}






// WEBPACK FOOTER //
// ./src/scripts/app/modules/hubspot/actions.js